import { Pipe, PipeTransform } from '@angular/core';
import { IAddress } from '../../core/models/IAddress';

@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {

  transform(address: IAddress | null | undefined): string {
    if (!address) return '';

    const { street, number, zipCode, city, country } = address;

    // Construit la string avec des vérifications basiques
    const streetPart = [street, number].filter(Boolean).join(' ');
    const cityPart = [zipCode, city].filter(Boolean).join(' ');

    return [streetPart, cityPart].filter(Boolean).join(', ');
  }
}
